import { Collapse } from 'antd';
import moment from 'moment';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { ChevronRight } from '../../assets/icons';
import { getUsCurrencyFormat, getUsPercentageFormat } from '../../utils/usCurrencyFormatter';
import './SMDividend.scss';

const { Panel } = Collapse;
const DIVIDEND_DATA = (props) => {
  const {
    data: {
      totalDividendAmount = '0',
      dividendPerShare = '',
      dividendPercentage = '',
      managementFees = '0',
      loanRepayment = '0',
      insurance = '0',
      propertyTax = '0',
      otherExpenses = '0',
      quarter = '',
      totalShares = 0,
    } = {},
    rent = 0,
  } = props;

  return [
    <div className='smdividend-data-content'>
      <h4 className='fz-16 fw-600'>Dividend breakdown</h4>
      <div className='data'>
        <div className='data__item'>
          <span className='data__item__label'>Q{moment(quarter).quarter()} rent collected</span>
          <span className='data__item__value dark'>${getUsCurrencyFormat(Number(rent) || 0)}</span>
        </div>
        <hr className='mt-6 mb-6' />
        <div className='data__item'>
          <span className='data__item__label'>Management fee</span>
          <span className='data__item__value'>-${getUsCurrencyFormat(Number(managementFees) || 0)}</span>
        </div>
        <div className='data__item'>
          <span className='data__item__label'>Loan payment</span>
          <span className='data__item__value'>-${getUsCurrencyFormat(Number(loanRepayment) || 0)}</span>
        </div>
        <div className='data__item'>
          <span className='data__item__label'>Insurance</span>
          <span className='data__item__value'>-${getUsCurrencyFormat(Number(insurance) || 0)}</span>
        </div>
        <div className='data__item'>
          <span className='data__item__label'>Property tax</span>
          <span className='data__item__value'>-${getUsCurrencyFormat(Number(propertyTax) || 0)}</span>
        </div>
        <hr className='mt-6 mb-6' />
        {Number(otherExpenses) ? (
          <div className='data__item'>
            <span className='data__item__label'>Other Expenses</span>
            <span className='data__item__value'>-${getUsCurrencyFormat(Number(otherExpenses) || 0)}</span>
          </div>
        ) : (
          ''
        )}
        <div className='data__item'>
          <span className='data__item__label'>Dividend total</span>
          <span className='data__item__value'>${getUsCurrencyFormat(Number(totalDividendAmount) || 0)}</span>
        </div>
        <div className='data__item'>
          <span className='data__item__label'>Total shares</span>
          <span className='data__item__value'>{Number(totalShares || 0)}</span>
        </div>
        <hr className='mt-6 mb-6' />
        <div className='data__item'>
          <span className='data__item__label dark'>Div per share</span>
          <span className='data__item__value dark'>
            ${getUsCurrencyFormat(Number(dividendPerShare) || 0)} ({getUsPercentageFormat(Number(dividendPercentage) || 0)}%)
          </span>
        </div>
      </div>
    </div>,
  ];
};
const SMDividend = (props) => {
  const { loading = true, data: { data: { dividends = [] } = {} } = {} } = useSelector((state) => state.tradeDetails);

  const dividendData = useMemo(() => {
    if (!loading) {
      if (dividends.length) {
        return dividends?.map((data, i) => {
          const {
            totalDividendAmount = '0',
            managementFees = '0',
            loanRepayment = '0',
            insurance = '0',
            propertyTax = '0',
            otherExpenses = '0',
          } = data;
          const rent =
            Number(totalDividendAmount || 0) +
              Number(managementFees || 0) +
              Number(loanRepayment || 0) +
              Number(insurance || 0) +
              Number(propertyTax || 0) +
              Number(otherExpenses || 0) || 0;
          return (
            <Panel
              header={`Q${moment(data?.quarter).quarter()} ${moment(data?.quarter).year()}`}
              key={`${i + 1}`}
              extra={`$${getUsCurrencyFormat(Number(rent) || 0)}`}
            >
              <DIVIDEND_DATA data={data} rent={rent} />
            </Panel>
          );
        });
      }
      return [];
    }
    return [];
  }, [loading, dividends]);
  return (
    <div className='mb-48 smdividend'>
      <p className='fz-20 fw-600 mb-16'>Dividend History</p>
      <div className='smdividend-data'>
        {dividendData.length ? (
          <Collapse defaultActiveKey={['1']} expandIcon={() => <ChevronRight size={18} />}>
            {React.Children.toArray(dividendData)}
          </Collapse>
        ) : (
          'No Data Available'
        )}
      </div>
    </div>
  );
};

export default SMDividend;
